import React from 'react'
import { Row } from 'reactstrap'

const Notifications = () => {
    
  return (
    <div className='card border border-2 shadow experience-section h-100'>
        <div className="card-body">
            <div className='mb-3'>
                <h4>Notification Setting</h4>
            </div> 
            <div>
                <Row>
                  <div className="col-md-6">

                    <div className='mb-4 col-10'>
                        <table>
                            <thead>
                                <th className='notification_title'>Sales</th>
                                <th className='notification_action'>Web</th>
                                <th className='notification_action'>Email</th>
                                <th className='notification_action'>Mobile</th>
                            </thead>
                            <tbody>

                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Leads & Followups
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                </tr>
       
                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Proposal List
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                </tr>

                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Pending Contracts
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                </tr>
                                
                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Converted Customers
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className='mb-4 col-10'>
                        <table>
                            <thead>
                                <th className='notification_title'>Marketing</th>
                                <th className='notification_action'></th>
                                <th className='notification_action'></th>
                                <th className='notification_action'></th>
                            </thead>
                            <tbody>

                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Opportunitys
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                </tr>
       
                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Cold Calling
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                </tr>

                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Bookings
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                
                               
                            </tbody>
                        </table>
                    </div>

                    <div className='mb-4 col-10'>
                        <table>
                            <thead>
                                <th className='notification_title'>Human Resources</th>
                                <th className='notification_action'></th>
                                <th className='notification_action'></th>
                                <th className='notification_action'></th>
                            </thead>
                            <tbody>

                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Punch Details
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                </tr>
       
                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Leaves Management
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                </tr>

                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Salary Sheet
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                
                               
                            </tbody>
                        </table>
                    </div>
                  </div>


                  <div className="col-md-6 ps-4 border-left" >

                    <div className='mb-4 col-10'>
                        <table>
                            <thead>
                                <th className='notification_title'>Work</th>
                                <th className='notification_action'>Web</th>
                                <th className='notification_action'>Email</th>
                                <th className='notification_action'>Mobile</th>
                            </thead>
                            <tbody>

                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Resource Plannig
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                </tr>
       
                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Timers
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                </tr>

                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            General Tasks
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                </tr>
                                
                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Tickets
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className='mb-4 col-10'>
                        <table>
                            <thead>
                                <th className='notification_title'>Audit Logs</th>
                                <th className='notification_action'></th>
                                <th className='notification_action'></th>
                                <th className='notification_action'></th>
                            </thead>
                            <tbody>

                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Roles & Permissions
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                </tr>
       
                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                                Logins
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                </tr>

                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Punch Logs
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Cron Logs
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                </tr>
                                
                               
                            </tbody>
                        </table>
                    </div>

                    <div className='mb-4 col-10'>
                        <table>
                            <thead>
                                <th className='notification_title'>Finance</th>
                                <th className='notification_action'></th>
                                <th className='notification_action'></th>
                                <th className='notification_action'></th>
                            </thead>
                            <tbody>

                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Expenses
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                </tr>
       
                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Inventory Information
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                </tr>

                                <tr className='custom_table_row'>
                                    <td>
                                        <span>
                                            <i className="bi bi-arrow-right pe-2"></i>
                                            Pending Invoices
                                        </span>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked="checked"
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className="form-switch form-switch-md">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizemd"
                                            defaultChecked={false}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                  </div>
                 
                </Row>
              </div>           
        </div>
    </div>
  )
}

export default Notifications